/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { FiX } from 'react-icons/fi';
import './PackageFilters.scss';

const GROUPS = [
  { key: 'duration', title: 'Trip Length' },
  { key: 'month', title: 'Departure Month' },
  { key: 'supplier', title: 'Supplier' },
];

/**
 * Pill filters in the eSIM sidebar style. A group is only shown when it can
 * actually narrow this result set (two or more options).
 */
function PackageFilters({ options, filters, onChange, activeCount, onClose }) {
  const toggle = (group, key) => {
    const current = new Set(filters[group] || []);
    if (current.has(key)) current.delete(key);
    else current.add(key);
    onChange({ ...filters, [group]: [...current] });
  };

  const groups = GROUPS.filter((g) => (options[g.key] || []).length > 1);

  return (
    <aside className="pkg-filters">
      <header className="pkg-filters__head">
        <h3>
          Filters
          {activeCount > 0 && <span>{activeCount}</span>}
        </h3>
        <div className="pkg-filters__head-actions">
          {activeCount > 0 && (
            <button
              type="button"
              className="pkg-filters__clear"
              onClick={() =>
                onChange({ duration: [], month: [], supplier: [] })
              }
            >
              Clear all
            </button>
          )}
          {onClose && (
            <button
              type="button"
              className="pkg-filters__close"
              onClick={onClose}
              aria-label="Close filters"
            >
              <FiX />
            </button>
          )}
        </div>
      </header>

      {groups.length === 0 && (
        <p className="pkg-filters__none">
          Nothing to filter — every package here shares the same options.
        </p>
      )}

      {groups.map((g) => (
        <section className="pkg-filters__group" key={g.key}>
          <h4>{g.title}</h4>
          <div className="pkg-filters__pills">
            {options[g.key].map((o) => {
              const active = (filters[g.key] || []).includes(o.key);
              return (
                <button
                  key={o.key}
                  type="button"
                  aria-pressed={active}
                  className={`pkg-filters__pill ${
                    active ? 'pkg-filters__pill--active' : ''
                  }`}
                  onClick={() => toggle(g.key, o.key)}
                >
                  {o.label}
                  <span>{o.count}</span>
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </aside>
  );
}

PackageFilters.propTypes = {
  options: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  activeCount: PropTypes.number,
  onClose: PropTypes.func,
};

PackageFilters.defaultProps = {
  activeCount: 0,
  onClose: null,
};

export default PackageFilters;
